import React, {useEffect, useMemo, useState} from 'react';
import {FormProvider, useForm} from "react-hook-form";
import {getLanguage, t} from "react-switch-lang";
import SelectInfinite from '../../../../../components/FormFields/SelectInfinite'
import * as yup from "yup";
import {Row, Col, Spinner} from 'react-bootstrap';
import {yupResolver} from "@hookform/resolvers";
import InputText from "../../../../../components/FormFields/InputText";
import InputDate from '../../../../../components/FormFields/inputDate/InputDate'
import TextArea from "../../../../../components/FormFields/Textarea";
import {
  createProposalForm,
  editProposalForm,
  getProposalForm,
  getProposalOverallRiskAssessmentLevels,
} from '../../../../../services/externalizations/proposalFormService';
import {Toast} from '../../../../../utils/sweetAlert';
import {format, parseISO} from 'date-fns';
import {useUserContext} from '../../../../../contexts/UserContext';
import {useParams} from "react-router-dom";
import {getDepartment} from "../../../../../services/IncurredEvent/incurredEventApi";
import SelectList from "../../../../../components/FormFields/select/SelectList";
import {
  customStyles, handleCancelExternalization,
  possessionOfLicencesOptions,
  references, statusesOfVerification,
  yesNoOptions,
} from '../../../../../utils/externalizationFormOptions';
import {
  deleteFile,
  uploadProponentFormFile,
} from '../../../../../services/externalizations/fileUploadService';
import Swal from 'sweetalert2';
import VerifyExternalizationModal from '../../../components/verifyExternalizationModal/VerifyExternalizationModal';
import FormActionButtons from '../../../components/formActionButtons/FormActionButtons';
import CriticalExternalizationForm from "./components/CriticalExternalizationForm";
import ContractForm from "./components/ContractForm";
import FilesSection from "./components/FilesSection";
import {appModules} from '../../../../../utils/const';

function RiskProponent({cycleId, isLastCycle, isEditAllowedByStatus, externalizationData,externalizationFormConfigData}) {
    const [proponentFormValues,setProponentFormValues] = useState([]);
    const [proposalFormId, setProposalFormId] = useState()
    const [disabled, setDisabled] = useState(false);
    const [isReview, setIsReview] = useState(false);
    const [showEditBtn, setShowEditBtn] = useState(false);
    const [bankingServicesRelated, setBankingServicesRelated]= useState(false)
    const [couldAffectRiskManagement, setCouldAffectRiskManagement]= useState(false)
    const [affectsInternalControl, setAffectsInternalControl]= useState(false)
    const [coreBusinessActivitiesInvolved, setCoreBusinessActivitiesInvolved]= useState(false);
    const [regulatoryConsentRequired, setRegulatoryConsentRequired]= useState(false)
    const [multipleContractsWithCurrentProvider, setMultipleContractsWithCurrentProvider]= useState(false)
    const [totalRiskAssessment, setTotalRiskAssessment] = useState([])
    const [responsibleUserId, setResponsibleUserId] = useState()
    const [riskDescription, setRiskDescription] = useState('')
    const [isContractSigned,setIsContractSigned] = useState(false);
    const [deputyUserInChargeForExternalizationFullName,setDeputyUserInChargeForExternalizationFullName] = useState();
    const [userInChargeForExternalizationId,setUserInChargeForExternalizationId] = useState();
    const [userInChargeForExternalizationFullName,setUserInChargeForExternalizationFullName] = useState();
    const [userResponsibleForExternalizationId,setUserResponsibleForExternalizationId] = useState();
    const [userResponsibleForExternalizationFullName,setUserResponsibleForExternalizationFullName] = useState();
    const [deputyUserInChargeForExternalizationId,setDeputyUserInChargeForExternalizationId] = useState();
  const [inputKey, setInputKey] = useState(0);
  const [edit,setEdit] = useState(showEditBtn);
  const [isUploading, setIsUploading] = useState({})
  const lang = getLanguage();
  const user = useUserContext();
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [verificationStatus, setVerificationStatus]= useState('')
  const canVerify = verificationStatus === 'PENDING'
  const userCanVerifyForm = user?.id === responsibleUserId
  const toggleVerifyModal = () => setVerifyModalOpen(prev => !prev);
    const [files, setFiles] = useState({
    financialStatements: null,
    auditReport: null,
    taxClearance: null,
    licensesPermits: null,
    keyPersonnelCv: null,
    registryExtract: null,
    externalizationProposalJustification: null,
    contractDraft: null,
    otherFiles: null
  })
  const isCriticalExternalization = useMemo(() =>
      bankingServicesRelated ||
      couldAffectRiskManagement ||
      affectsInternalControl ||
      coreBusinessActivitiesInvolved ||
      regulatoryConsentRequired ||
      multipleContractsWithCurrentProvider,
    [bankingServicesRelated, couldAffectRiskManagement, affectsInternalControl, coreBusinessActivitiesInvolved, regulatoryConsentRequired, multipleContractsWithCurrentProvider]);
  const schema = yup.object().shape({
      externalizationType: yup.string()
          .trim()
          .required(t('message.fieldRequired'))
          .min(2, t('message.min', {min: 2}))
          .max(255, t('message.max', {max: 255})),
      lastCriticalityAssessmentDate: yup
          .date()
          .nullable()
          .typeError(t('message.fieldRequired'))
          .required(t('message.fieldRequired')),
      cloudServiceTypeAndImplementationModel: yup.string()
          .trim()
          .required(t('message.fieldRequired'))
          .min(2, t('message.min', {min: 2}))
          .max(500, t('message.max', {max: 500})),
      departmentInCharge: yup.object().nullable().required(t('message.fieldRequired')),
      processingDate: yup
            .date()
            .nullable()
            .typeError(t('message.fieldRequired'))
            .required(t('message.fieldRequired')),
    nextRevisionDate: yup
      .date()
      .nullable()
      .when('$edit', {
        is: true,
        then: (schema) =>
          schema
            .required(t('message.fieldRequired'))
            .min(
              yup.ref('processingDate'),
              t('message.nextRevisionDateAfterProcessingDate')
            ),
        otherwise: (schema) =>
          schema.notRequired().min(
            yup.ref('processingDate'),
            t('message.nextRevisionDateAfterProcessingDate')
          ),
      }),
    dataLocation: yup
            .string()
            .trim()
            .required(t('message.fieldRequired'))
            .min(2, t('message.min', {min: 2}))
            .max(100, t('message.max', {max: 100})),
    serviceProviderCountry: yup
            .string()
            .trim()
            .required(t('message.fieldRequired'))
      .min(2, t('message.min', {min: 2}))
      .max(100, t('message.max', {max: 100})),
    proposal: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .min(2, t('message.min', {min: 2}))
      .max(2000, t('message.max', {max: 2000})),
      includesPersonalData: yup.object().nullable().required(t('message.fieldRequired')),
        businessExperienceRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
        qualityOfServiceRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
        staffQualityRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
        financialRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
        proposalOverallRiskAssessmentLevel: yup.object().nullable(),
    licensesCertificates:yup.object().nullable().required(t('message.fieldRequired')),
    references:yup.object().nullable().required(t('message.fieldRequired')),
        comment: yup
            .string()
            .trim()
            .max(2000, t('message.max', {max: 2000})),
      businessContinuityMeasuresAndTestingReportsSubmitted: yup.object()
          .nullable()
          .required(t('message.fieldRequired')),
      subcontractors: yup
          .string()
          .trim()
          .max(500, t('message.max', {max: 500})),
      isServiceProviderBankOwned: yup.object().nullable().when('$isCriticalExternalization', {
          is: true,
          then: schema => schema.required(t('message.fieldRequired')),
          otherwise: schema => schema.notRequired(),
      }),
      lastExternalizationRelatedRiskAssessmentResults: yup
        .string()
        .trim()
        .max(100, t('message.max', {max: 100})),
      alternativeServiceProviders: yup
        .string()
        .trim()
        .when('$isCriticalExternalization', {
          is: true,
          then: schema => schema.required(t('message.fieldRequired'))
            .min(2, t('message.min', {min: 2})),
          otherwise: schema => schema.notRequired(),
        })
        .max(100, t('message.max', {max: 100})),
    externalizationApprovingAuthority: yup
        .string()
        .trim()
         .when('$isCriticalExternalization', {
          is: true,
          then: schema => schema.required(t('message.fieldRequired'))
            .min(2, t('message.min', {min: 2})),
          otherwise: schema => schema.notRequired(),
        })
        .max(100, t('message.max', {max: 100})),
    supportsTimeCriticalOperations: yup.object().nullable().when('$isCriticalExternalization', {
          is: true,
          then: schema => schema.required(t('message.fieldRequired')),
          otherwise: schema => schema.notRequired(),
        }),
    disputeResolutionJurisdiction: yup
        .string()
        .trim()
         .when('$isCriticalExternalization', {
          is: true,
          then: schema => schema.required(t('message.fieldRequired'))
            .min(2, t('message.min', {min: 2})),
          otherwise: schema => schema.notRequired(),
        })
        .max(100, t('message.max', {max: 100})),
      assessmentOfDiscontinuationImpact: yup
          .string()
          .trim()
          .when('$isCriticalExternalization', {
              is: true,
              then: schema => schema.required(t('message.fieldRequired'))
                  .min(2, t('message.min', {min: 2})),
              otherwise: schema => schema.notRequired(),
          })
          .max(1000, t('message.max', {max: 1000})),
    estimatedAnnualCostAmount: yup
        .string()
        .trim()
         .when('$isCriticalExternalization', {
          is: true,
          then: schema => schema.required(t('message.fieldRequired'))
            .min(2, t('message.min', {min: 2})),
          otherwise: schema => schema.notRequired(),
        })
        .max(100, t('message.max', {max: 100})),
    contractNumber: yup
      .string()
      .trim()
      .max(100, t('message.max', {max: 100})),
    contractTitle: yup
      .string()
      .trim()
      .max(100, t('message.max', {max: 100})),
    });
    const methods = useForm({
        resolver: yupResolver(schema),
      context: { isCriticalExternalization,isContractSigned },
    });
    const { id } = useParams();
    const {handleSubmit,setValue,watch,reset} = methods;
    const financialRiskLevel = watch('financialRiskLevel');
    const staffQualityRiskLevel = watch('staffQualityRiskLevel');
    const serviceQuality = watch('qualityOfServiceRiskLevel');
    const businessExperienceRiskLevel = watch('businessExperienceRiskLevel');
    const selectedDepartment = watch("departmentInCharge");
    const proposalOverallRiskAssessmentLevel = watch("proposalOverallRiskAssessmentLevel");
  const values = [
    financialRiskLevel?.value,
    staffQualityRiskLevel?.value,
    serviceQuality?.value,
    businessExperienceRiskLevel?.value
  ].filter(v => v != null);
 const rawMaxValue = values.length ? Math.max(...values) : null;
  const maxValue = rawMaxValue != null ? rawMaxValue - 1 : null;
    const [loading, setLoading] = useState(true);
    const [populated, setPopulated] = useState(false);

  useEffect(()=> {
    if(selectedDepartment?.value) {
      async function getDepartmentUserInCharge() {
        const {data} = await getDepartment(selectedDepartment?.value);
        setDeputyUserInChargeForExternalizationFullName(data[0]?.deputyUserInChargeForExternalizationFullName)
        setDeputyUserInChargeForExternalizationId(data[0]?.deputyUserInChargeForExternalizationId)
        setUserInChargeForExternalizationId(data[0]?.userInChargeForExternalizationId)
        setUserInChargeForExternalizationFullName(data[0]?.userInChargeForExternalizationFullName)
        setUserResponsibleForExternalizationId(data[0]?.userResponsibleForExternalizationId)
        setUserResponsibleForExternalizationFullName(data[0]?.userResponsibleForExternalizationFullName)
      }
      getDepartmentUserInCharge()
    }
  },[selectedDepartment])

    const submitForm = async (data) => {
      const requiredFilesLabels = {
        financialStatements: t('externalization.riskProponentForm.financialStatement'),
        taxClearance: t('externalization.riskProponentForm.taxObligations'),
        // keyPersonnelCv: t('externalization.riskProponentForm.CV'),
        externalizationProposalJustification: t('externalization.riskProponentForm.externalizationProposalJustification'),
        // auditReport: t('externalization.riskProponentForm.auditReport'),
        // licensesPermits: t('externalization.riskProponentForm.licences'),
        registryExtract: t('externalization.riskProponentForm.registerExtract')
      };
      for (const field in requiredFilesLabels) {
        if (!files[field] || files[field].length === 0) {
          Toast.fire({
            icon: "error",
            title: t("externalization.addFileMessage") + `${ requiredFilesLabels[field]}`
          });
          setDisabled(false);
          return;
        }
      }

      const formatProcessingDate =
      format(new Date(data?.processingDate), 'yyyy-MM-dd');
      const formatContractStartDate  =data?.contractStartDate ?
      format(new Date(data?.contractStartDate), 'yyyy-MM-dd') : null
      const formatContractEndDate  = data?.contractEndDate ?
      format(new Date(data?.contractEndDate), 'yyyy-MM-dd') : null
      const formatNextRevisionDate  = data?.nextRevisionDate ?
      format(new Date(data?.nextRevisionDate), 'yyyy-MM-dd') : null
        const formatCriticalityAssessmentDate =
        format(new Date(data?.lastCriticalityAssessmentDate), 'yyyy-MM-dd');

      setDisabled(true);
      const dataToSubmit = {
        externalizationType: data?.externalizationType,
        lastCriticalityAssessmentDate: formatCriticalityAssessmentDate,
        cloudServiceTypeAndImplementationModel: data?.cloudServiceTypeAndImplementationModel,
        departmentInCharge: {id: data?.departmentInCharge?.value},
        processingDate: formatProcessingDate,
        nextRevisionDate: formatNextRevisionDate,
        dataLocation: data?.dataLocation,
        serviceProviderCountry: data?.serviceProviderCountry,
        proposal: data?.proposal,
        includesPersonalData: data?.includesPersonalData?.value,
        financialRiskLevel: {id: data?.financialRiskLevel?.value},
        businessExperienceRiskLevel: {id:data?.businessExperienceRiskLevel?.value},
        qualityOfServiceRiskLevel:{id: data?.qualityOfServiceRiskLevel?.value},
        proposalOverallRiskAssessmentLevel: {id:data?.proposalOverallRiskAssessmentLevel?.value},
        staffQualityRiskLevel: {id: data?.staffQualityRiskLevel?.value},
        comment: data?.comment,
        businessContinuityMeasuresAndTestingReportsSubmitted: data?.businessContinuityMeasuresAndTestingReportsSubmitted?.value,
        subcontractors: data?.subcontractors,
        references: data?.references?.value,
        licensesCertificates: data?.licensesCertificates?.value,
        cycle: {id: parseInt(cycleId)},
        formConfig: externalizationFormConfigData,
        responsibleUser: {id: userResponsibleForExternalizationId},
        userInCharge: {id: userInChargeForExternalizationId},
        userInChargeDeputy: {id: deputyUserInChargeForExternalizationId},
          ...(edit && {
              id: proponentFormValues?.id ? proponentFormValues?.id : proposalFormId,
            firstVerifiedAt: proponentFormValues?.firstVerifiedAt
          }),
        populated: true,
        critical: isCriticalExternalization,
        bankingServicesRelated: bankingServicesRelated,
        couldAffectRiskManagement: couldAffectRiskManagement,
        affectsInternalControl: affectsInternalControl,
        coreBusinessActivitiesInvolved: coreBusinessActivitiesInvolved,
        regulatoryConsentRequired: regulatoryConsentRequired,
        multipleContractsWithCurrentProvider: multipleContractsWithCurrentProvider,
        isServiceProviderBankOwned: data?.isServiceProviderBankOwned?.value,
        lastExternalizationRelatedRiskAssessmentResults: data?.lastExternalizationRelatedRiskAssessmentResults,
        alternativeServiceProviders: data?.alternativeServiceProviders,
        supportsTimeCriticalOperations: data?.supportsTimeCriticalOperations?.value,
        externalizationApprovingAuthority: data?.externalizationApprovingAuthority,
        disputeResolutionJurisdiction: data?.disputeResolutionJurisdiction,
        estimatedAnnualCostAmount: data?.estimatedAnnualCostAmount,
        assessmentOfDiscontinuationImpact: data?.assessmentOfDiscontinuationImpact,
        isContractSigned: isContractSigned,
        contractNumber: data?.contractNumber,
        contractTitle: data?.contractTitle,
        contractStartDate: formatContractStartDate,
        contractEndDate: formatContractEndDate,
      };
      if (edit) {
        try {
          const res = await editProposalForm(proponentFormValues?.id ? proponentFormValues.id : proposalFormId, dataToSubmit)
          if (res?.status === 200) {
            Toast.fire({
              title: t('departments.message.updateSuccess', {
                entity: t('externalization.riskProponentForm.addProposal'),
              }),
              icon: 'success',
            });
            const newVerificationStatus = res?.data?.verificationStatus;
            if (newVerificationStatus && newVerificationStatus !== verificationStatus) {
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              setVerificationStatus(newVerificationStatus);
              setDisabled(true);
            }
          }
          await window.location.reload();
          setDisabled(true);
        }
        catch (err){
          if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
            Swal.fire({
              text:
                lang === 'eng'
                  ? err.response.data.description
                  : t('message.responsibleUserForExternalizationMissing'),
              icon: 'error',
            });
            setDisabled(false)
            setEdit(false)
          } else {
            Toast.fire({
              title: t('message.errorApi'),
              icon: 'error',
            });
          }
        }
      }else {
        try {
         const response = await createProposalForm(dataToSubmit)
            if (response?.status >= 200 && response?.status <= 299) {
            await Toast.fire({
                title: t('departments.message.addSuccess', {
                  entity: t('externalization.riskProponentForm.addProposal'),
                }),
                icon: 'success',
              });
              setDisabled(true)
              setEdit(true)
              setIsReview(true);
              setVerificationStatus(response?.data?.verificationStatus)
              setResponsibleUserId(userResponsibleForExternalizationId);
              setProposalFormId(response?.data?.id)
              await window.location.reload();
            }
            setDisabled(true)
        }
        catch (err){
          if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
            Swal.fire({
              text:
                lang === 'eng'
                  ? err.response.data.description
                  : t('message.responsibleUserForExternalizationMissing'),
              icon: 'error',
            });
            setDisabled(false)
            setEdit(false)
          } else {
            Toast.fire({
              title: t('message.errorApi'),
              icon: 'error',
            });
          }
        }
      }
    }
  useEffect(() => {
    async function fetchRiskLevels() {
      const {data} = await getProposalOverallRiskAssessmentLevels();
      const validLevels = data.filter(r => r.value >= 0 && r.value <= 2);
      setTotalRiskAssessment(validLevels);
    }
    fetchRiskLevels();
  }, []);
  function getRiskAssessmentDTO(riskValue, riskLevelList) {
    return riskLevelList.find(r => r.value === riskValue);
  }
  useEffect(() => {
    if (maxValue != null && totalRiskAssessment.length > 0) {
      const dto = getRiskAssessmentDTO(maxValue, totalRiskAssessment);
      if(dto) {
        const transformed = {
          value: dto.id,
          label: lang === 'mne' ? dto.name : dto.nameEn
        };
        setValue('proposalOverallRiskAssessmentLevel', transformed);
      }
    }
  }, [financialRiskLevel,
    staffQualityRiskLevel,
    serviceQuality, businessExperienceRiskLevel,totalRiskAssessment]);
  useEffect(() => {
    if (proposalOverallRiskAssessmentLevel && totalRiskAssessment.length > 0) {
      const matchedRisk = totalRiskAssessment.find(
        (item) => item.id === proposalOverallRiskAssessmentLevel.value
      );
      if (matchedRisk) {
        setRiskDescription({
          value: matchedRisk.value,
          label: lang === 'mne' ? matchedRisk.description : matchedRisk.descriptionEn,
        });
      }
    }
  }, [proposalOverallRiskAssessmentLevel, totalRiskAssessment]);
    useEffect(() => {
      if (!cycleId) return
        async function fetchProposalForm() {
            setLoading(true);
            try {
                const res = await getProposalForm(cycleId);
                const form = res?.data?.[0] ?? null;
                if (form?.id) {
                    setProponentFormValues(form);
                    setResponsibleUserId(form?.departmentInCharge?.userResponsibleForExternalizationId);
                    setPopulated(!!form?.populated);
                    setEdit(!!form?.populated);
                    setDisabled(!!form?.populated);
                    setVerificationStatus(form?.verificationStatus)
                    const userId = user?.id;
                    const deputyId = form?.departmentInCharge?.deputyUserInChargeForExternalizationId;
                    const mainId = form?.departmentInCharge?.userInChargeForExternalizationId;
                    const isUserReviewer = userId === deputyId || userId === mainId;
                    setIsReview(!!form?.populated && isUserReviewer);
                    setShowEditBtn(!form?.populated === false || !isUserReviewer);
                } else {
                    setPopulated(false);
                    setEdit(false);
                    setDisabled(false);
                    setValue('processingDate', new Date());
                  setFiles(prev => ({
                    ...prev,
                    ...(form?.files ?? {})
                  }));
                }
            } catch (err) {
                console.error('Error loading proposal form:', err);
                setPopulated(false);
            } finally {
                setLoading(false);
            }
        }

        fetchProposalForm();
    }, [cycleId]);

    useEffect(() => {
        if (proponentFormValues) {
            reset({
                financialRiskLevel: proponentFormValues?.financialRiskLevel
                    ? {
                        value: proponentFormValues.financialRiskLevel.id,
                        label: lang === 'eng' ? proponentFormValues.financialRiskLevel.nameEn :proponentFormValues.financialRiskLevel.name,
                    }
                    : null,
                staffQualityRiskLevel: proponentFormValues?.staffQualityRiskLevel
                    ? {
                        value: proponentFormValues.staffQualityRiskLevel.id,
                        label: lang === 'eng' ? proponentFormValues.staffQualityRiskLevel.nameEn :proponentFormValues.staffQualityRiskLevel.name,
                    }
                    : null,
                qualityOfServiceRiskLevel: proponentFormValues?.qualityOfServiceRiskLevel
                    ? {
                        value: proponentFormValues.qualityOfServiceRiskLevel.id,
                        label: lang === 'eng' ? proponentFormValues.qualityOfServiceRiskLevel.nameEn :proponentFormValues.qualityOfServiceRiskLevel.name,
                    }
                    : null,
                businessExperienceRiskLevel: proponentFormValues?.businessExperienceRiskLevel
                    ? {
                        value: proponentFormValues.businessExperienceRiskLevel.id,
                        label: lang === 'eng' ? proponentFormValues.businessExperienceRiskLevel.nameEn :proponentFormValues.businessExperienceRiskLevel.name,
                    }
                    : null,
                proposalOverallRiskAssessmentLevel: proponentFormValues?.proposalOverallRiskAssessmentLevel
                    ? {
                        value: proponentFormValues.proposalOverallRiskAssessmentLevel.id,
                        label: lang === 'eng' ? proponentFormValues.proposalOverallRiskAssessmentLevel.nameEn :proponentFormValues.proposalOverallRiskAssessmentLevel.name,
                    }
                    : null,
                departmentInCharge: proponentFormValues?.departmentInCharge
                    ? {
                        value: proponentFormValues.departmentInCharge.id,
                        label: lang === 'eng' ? proponentFormValues.departmentInCharge.nameEn : proponentFormValues.departmentInCharge.name,
                    }
                    : null,
                processingDate: proponentFormValues?.processingDate
                    ? parseISO(proponentFormValues?.processingDate)
                    : new Date(),
              lastCriticalityAssessmentDate: proponentFormValues?.lastCriticalityAssessmentDate
                    ? parseISO(proponentFormValues?.lastCriticalityAssessmentDate)
                    : null,
              lastRevisionDate: proponentFormValues?.lastRevisionDate
                    ? parseISO(proponentFormValues?.lastRevisionDate)
                    : null,
              nextRevisionDate: proponentFormValues?.nextRevisionDate
                    ? parseISO(proponentFormValues?.nextRevisionDate)
                    : null,
              contractStartDate: proponentFormValues?.contractStartDate
                    ? parseISO(proponentFormValues?.contractStartDate)
                    : null,
              contractEndDate: proponentFormValues?.contractEndDate
                    ? parseISO(proponentFormValues?.contractEndDate)
                    : null,
              regulatoryConsentRequired: proponentFormValues?.regulatoryConsentRequired,
              includesPersonalData: typeof proponentFormValues?.includesPersonalData === 'boolean'
                ? yesNoOptions.find(
                  (status) => status.value === proponentFormValues.includesPersonalData
                )
                : null,
              isServiceProviderBankOwned: typeof proponentFormValues?.isServiceProviderBankOwned === 'boolean'
                ? yesNoOptions.find(
                  (status) => status.value === proponentFormValues.isServiceProviderBankOwned
                )
                : null,
                businessContinuityMeasuresAndTestingReportsSubmitted: typeof proponentFormValues?.businessContinuityMeasuresAndTestingReportsSubmitted === 'boolean'
                    ? yesNoOptions.find(
                        (status) => status.value === proponentFormValues.businessContinuityMeasuresAndTestingReportsSubmitted
                    )
                    : null,
                supportsTimeCriticalOperations: typeof proponentFormValues?.supportsTimeCriticalOperations === 'boolean'
                    ? yesNoOptions.find(
                        (status) => status.value === proponentFormValues.supportsTimeCriticalOperations
                    )
                    : null,
              licensesCertificates: proponentFormValues?.licensesCertificates
                ? possessionOfLicencesOptions.find(
                  (status) => status.value === proponentFormValues.licensesCertificates
                )
                : null,
              verificationStatus: proponentFormValues?.verificationStatus
                ? statusesOfVerification.find(
                  (status) => status.value === verificationStatus
                )
                : null,
                references: proponentFormValues?.references
                    ? references.find(
                        (status) => status.value === proponentFormValues.references
                    )
                    : null
            });
          setBankingServicesRelated(!!proponentFormValues?.bankingServicesRelated);
          setCouldAffectRiskManagement(!!proponentFormValues?.couldAffectRiskManagement);
          setAffectsInternalControl(!!proponentFormValues?.affectsInternalControl);
          setCoreBusinessActivitiesInvolved(!!proponentFormValues?.coreBusinessActivitiesInvolved);
          setRegulatoryConsentRequired(!!proponentFormValues?.regulatoryConsentRequired);
          setMultipleContractsWithCurrentProvider(!!proponentFormValues?.multipleContractsWithCurrentProvider);
          setIsContractSigned(!!proponentFormValues?.isContractSigned)
        }
      if (proponentFormValues?.files) {
        const fileFields = [
          'financialStatements',
          'auditReport',
          'taxClearance',
          'licensesPermits',
          'keyPersonnelCv',
          'registryExtract',
          'externalizationProposalJustification',
          'contractDraft',
          'otherFiles'
        ];

        const formattedFiles = fileFields.reduce((acc, key) => {
          const filesArray = proponentFormValues.files[key];
          acc[key] = Array.isArray(filesArray)
            ? filesArray.map(file => ({
              fileName: file?.fileName,
              downloadUrl: file?.downloadUrl,
              id: file?.id
            }))
            : [];
          return acc;
        }, {});

        setFiles(formattedFiles);
      }
    }, [proponentFormValues, reset]);
  const handleFileUploadExternal = async (newFiles, fieldName, slotKey) => {
    const input = document.getElementById(`upload-${fieldName}`);
    if (!input || !input.files.length) return;
    setIsUploading(prev => ({ ...prev, [fieldName]: true }));
    const newUploadedFiles = [];
    try {
    for (const file of input.files) {
      const formData = new FormData();
      formData.append('file', file);
        const response = await uploadProponentFormFile(id, slotKey, formData);
        if (response?.data?.id) {
          newUploadedFiles.push({
            id: response.data.id,
            fileName: file.name,
            downloadUrl: response.data.downloadUrl || null
          });
        }
    }

    if (newUploadedFiles.length > 0) {
      setFiles(prev => ({
        ...prev,
        [fieldName]: [...(prev[fieldName] || []), ...newUploadedFiles],
      }));

      Toast.fire({
        title: t('message.addSuccess2', {entity: t('externalization.riskProponentForm.file')}),
        icon: 'success',
      });
    }
  } catch (err) {
      console.error("Upload error", err);
    } finally {
      setIsUploading(prev => ({ ...prev, [fieldName]: false }));
      setInputKey(prev => prev + 1);
    }
  };
  const removeFile = async (fieldName, fileId) => {
    try {
      const response = await deleteFile(fileId, fieldName);
      if (response?.status === 204) {
        Toast.fire({
          title: t('message.deleteSuccess2', {
            entity: t('externalization.riskProponentForm.file'),
          }),
          icon: 'success',
        });

        setFiles(prev => ({
          ...prev,
          [fieldName]: prev[fieldName].filter(f => f.id !== fileId),
        }));
      }
    } catch (error) {
      console.error("error", error);
    }
  };
    if (loading) {
        return (
            <div className="text-center mt-4 mb-4">
                <Spinner animation="border" role="status" />
            </div>
        );
    }
    return (
      <>
        <FormActionButtons
          isReview={isReview}
          edit={edit}
          disabled={disabled}
          isLastCycle={isLastCycle}
          isEditAllowedByStatus={isEditAllowedByStatus}
          userCanVerifyForm={userCanVerifyForm}
          canVerify={canVerify}
          toggleVerifyModal={toggleVerifyModal}
          setDisabled={setDisabled}
        />
            <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitForm)}>
            <Row className="mb-5 w-100 ml-1">
              <Row className="mb-2 w-100">
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">{t('departments.department')}</label>
                    <SelectInfinite
                        api={`/departments-by-user-in-charge-for-externalization/${user?.id}`}
                        name="departmentInCharge"
                        placeholder={t('incurred-risk.placeholder.department')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        defaultValue={proponentFormValues?.departmentInCharge?.id ? {label: lang === 'eng' ? proponentFormValues?.departmentInCharge?.nameEn :  proponentFormValues?.departmentInCharge?.name,
                          value: proponentFormValues?.departmentInCharge?.id} : null}
                        isDisabled={disabled}
                    />
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.date')}</label>
                  <InputDate
                    name="processingDate"
                    className={'date-input'}
                    disabled={disabled}
                    maxDate={new Date()}
                    defaultValue={proponentFormValues?.processingDate !== undefined ? format(new Date(proponentFormValues?.processingDate), 'yyyy-MM-dd') : new Date()}
                  />
                  {edit && (proponentFormValues?.lastRevisionDate !== null) && proponentFormValues?.id && <>
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.lastRevisionDate')}</label>
                  <InputDate
                    name="lastRevisionDate"
                    className={'date-input'}
                    disabled={true}
                  /> </>}
                  {edit && (proponentFormValues?.nextRevisionDate !== null) && proponentFormValues?.id && <>
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.nextRevisionDate')}</label>
                      <InputDate
                          name="nextRevisionDate"
                          className={'date-input'}
                          disabled={disabled}
                          minDate={new Date(proponentFormValues?.processingDate)}
                          placeholder={t('externalization.riskProponentForm.nextRevisionDate')}
                      />
                  </>}
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.proposal')}</label>
                  <TextArea
                    name="proposal"
                    className={`form-control text-area`}
                    placeholder={t('externalization.riskProponentForm.placeholder.proposal')}
                    disabled={disabled}
                    defaultValue={proponentFormValues?.proposal}
                  />
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.lastCriticalityAssessmentDate')}</label>
                  <InputDate
                    name="lastCriticalityAssessmentDate"
                    className={'date-input'}
                    disabled={disabled}
                    placeholder={t('externalization.riskProponentForm.placeholder.lastCriticalityAssessmentDate')}
                    defaultValue={proponentFormValues?.lastCriticalityAssessmentDate !== undefined ? format(new Date(proponentFormValues?.lastCriticalityAssessmentDate), 'yyyy-MM-dd') : new Date()}
                  />
                </Col>
                <Col className="col-6 col-xl-3">
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.personalInfo')}</label>
                  <SelectList
                    name="includesPersonalData"
                    className="select"
                    placeholder={t(
                      'externalization.riskProponentForm.placeholder.personalInfo'
                    )}
                    options={yesNoOptions}
                    isDisabled={disabled}
                    isClearable
                  />
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.place')}</label>
                  <InputText
                    type="text"
                    name="dataLocation"
                    className="form-control input-field"
                    placeholder={t('externalization.riskProponentForm.placeholder.place')}
                    disabled={disabled}
                    id="dataLocation"
                    defaultValue={proponentFormValues?.dataLocation}
                  />
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.country')}</label>
                  <InputText
                    type="text"
                    name="serviceProviderCountry"
                    className="form-control input-field"
                    placeholder={t('externalization.riskProponentForm.placeholder.country')}
                    disabled={disabled}
                    id="serviceProviderCountry"
                    defaultValue={proponentFormValues?.serviceProviderCountry}
                  />
                    <label className="label w-100 mt-2" htmlFor="riskEstimation">{t('externalization.riskProponentForm.experience')}</label>
                  <SelectInfinite
                    api="business-experience-risk-levels"
                    name="businessExperienceRiskLevel"
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    hasTooltipDescription={true}
                    placeholder={t('externalization.riskProponentForm.placeholder.experience')}
                    isDisabled={disabled}
                  />
                  <label className="label w-100 mt-2" htmlFor="riskEstimation">{t('externalization.riskProponentForm.serviceQuality')}</label>
                  <SelectInfinite
                    api="quality-of-service-risk-levels"
                    name="qualityOfServiceRiskLevel"
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    hasTooltipDescription={true}
                    placeholder={t('externalization.riskProponentForm.placeholder.serviceQuality')}
                    isDisabled={disabled}
                  />
                  <label className="label w-100 mt-2" htmlFor="riskEstimation">{t('externalization.riskProponentForm.qualityStaff')}</label>
                  <SelectInfinite
                    api="staff-quality-risk-levels"
                    name="staffQualityRiskLevel"
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    hasTooltipDescription={true}
                    placeholder={t('externalization.riskProponentForm.placeholder.qualityStaff')}
                    isDisabled={disabled}
                  />
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.externalizationType')}</label>
                  <InputText
                    type="text"
                    name="externalizationType"
                    className="form-control input-field"
                    placeholder={t('externalization.riskProponentForm.placeholder.externalizationType')}
                    disabled={disabled}
                    id="externalizationType"
                    defaultValue={proponentFormValues?.externalizationType}
                  />
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.cloudServiceTypeAndImplementationModel')}</label>
                  <InputText
                    type="text"
                    name="cloudServiceTypeAndImplementationModel"
                    className="form-control input-field"
                    placeholder={t('externalization.riskProponentForm.placeholder.cloudServiceTypeAndImplementationModel')}
                    disabled={disabled}
                    id="cloudServiceTypeAndImplementationModel"
                    defaultValue={proponentFormValues?.cloudServiceTypeAndImplementationModel}
                  />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2" htmlFor="riskEstimation">{t('externalization.riskProponentForm.financialRisk')}</label>
                    <SelectInfinite
                        api="financial-risk-levels"
                        name="financialRiskLevel"
                        hasTooltipDescription={true}
                        placeholder={t('externalization.riskProponentForm.placeholder.financialRisk')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={disabled}
                    />
                  <label className="label w-100 mt-2" htmlFor="proposalOverallRiskAssessmentLevel">{t('externalization.riskProponentForm.riskAssessment')}</label>
                  <SelectInfinite
                    options={totalRiskAssessment}
                    name="proposalOverallRiskAssessmentLevel"
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="select"
                    isDisabled={true}
                    placeholder={''}
                    styles={customStyles}
                    defaultValue={
                      proponentFormValues?.proposalOverallRiskAssessmentLevel?.id
                        ? {
                          value: proponentFormValues?.proposalOverallRiskAssessmentLevel?.id,
                          label:
                            lang === 'mne'
                              ? proponentFormValues?.proposalOverallRiskAssessmentLevel?.name
                              : proponentFormValues?.proposalOverallRiskAssessmentLevel?.nameEn
                        }
                        : null
                    }
                  />
                  <label className="label w-100 mt-2">{t('externalization.riskProponentForm.riskDesc')}</label>
                  <textarea
                    key={riskDescription}
                    value={riskDescription?.label}
                    type="text"
                    defaultValue={lang === 'mne' ? proponentFormValues?.proposalOverallRiskAssessmentLevel?.description : proponentFormValues?.proposalOverallRiskAssessmentLevel?.descriptionEn}
                    disabled={true}
                    rows={4}
                  />
                  <label className="label w-100 mt-2">{t('comments.comment')}
                    <span className="optional register line-height">{t('common.optional')}</span>
                  </label>
                  <TextArea
                    name="comment"
                    className={`form-control text-area`}
                    placeholder={t('placeholder.comment')}
                    disabled={disabled}
                    defaultValue={proponentFormValues?.comment?.length > 0 ? proponentFormValues?.comment : null}
                  />
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.reportsSubmitted')}
                    </label>
                    <SelectList
                        name="businessContinuityMeasuresAndTestingReportsSubmitted"
                        className="select"
                        options={yesNoOptions}
                        placeholder={t('externalization.riskProponentForm.placeholder.reportsSubmitted')}
                        isClearable={false}
                        isDisabled={disabled}
                    />
                </Col>
                  <Col className="col-6 col-xl-3">
                      <label className="label w-100 mt-2">{t('externalization.riskProponentForm.listOfEngagedSubcontractors')}
                          <span className="optional register line-height">{t('common.optional')}</span>
                      </label>
                      <InputText
                          name="subcontractors"
                          type="text"
                          className="form-control input-field"
                          placeholder={t('externalization.riskProponentForm.placeholder.listOfEngagedSubcontractors')}
                          disabled={disabled}
                          id="subcontractors"
                          defaultValue={proponentFormValues?.subcontractors}
                      />
                      <label className="label w-100 mt-2">{t('externalization.riskProponentForm.possessionOfLicences')}</label>
                      <SelectList
                          name="licensesCertificates"
                          className="select"
                          placeholder={t( 'externalization.riskProponentForm.placeholder.possessionOfLicences')}
                          options={possessionOfLicencesOptions}
                          isDisabled={disabled}
                          isClearable
                          showTooltip={true}
                      />
                      <label className="label w-100 mt-2">{t('externalization.riskProponentForm.references')}</label>
                      <SelectList
                          name="references"
                          className="select"
                          placeholder={t(
                              'externalization.riskProponentForm.placeholder.references'
                          )}
                          isDisabled={disabled}
                          options={references}
                          isClearable
                          showTooltip={true}
                      />

                    {edit && <>
                        <label className="label w-100 mt-2">{t('externalization.riskProponentForm.analysisDoneBy')}</label>
                        <InputText
                          type="text"
                          name="userInCharge"
                          className="form-control input-field"
                          disabled={true}
                          id="userInCharge"
                          defaultValue={userInChargeForExternalizationFullName}
                        />
                      {deputyUserInChargeForExternalizationId && <>
                        <label className="label w-100 mt-2">{t('departments.userInChargeReplacementForExternalization')}</label>
                      <InputText
                          type="text"
                          name="userInChargeDeputy"
                          className="form-control input-field"
                          disabled={true}
                          id="userInCharge"
                          defaultValue={deputyUserInChargeForExternalizationFullName}
                        /></>}
                          <label className="label w-100 mt-2">{t('externalization.riskProponentForm.verificationDoneBy')}</label>
                            <InputText
                              type="text"
                              name="responsibleUser"
                              className="form-control input-field"
                              disabled={true}
                              id="responsibleUser"
                              defaultValue={userResponsibleForExternalizationFullName}
                            />
                    <label className="label w-100 mt-2">{t('externalization.verificationStatus')}</label>
                    <InputText
                      name="verificationStatus"
                      type="text"
                      className="form-control input-field"
                      placeholder={t( 'externalization.placeholder.verificationStatus')}
                      disabled={true}
                      defaultValue={statusesOfVerification.find(
                        (status) => status.value === verificationStatus)?.label}
                    /></>}
                  </Col>
                  <FilesSection disabled={disabled} removeFile={removeFile} files={files}
                  inputKey={inputKey} handleFileUploadExternal={handleFileUploadExternal}
                                isUploading={isUploading}/>
              </Row>
            </Row>
            <Row>
                <Col>
                    <label className="font-weight-bold mb-4">
                        {t('externalization.riskProponentForm.assessmentCriticalityExternalization')}
                    </label>
                    <label className='d-flex align-items-start pr-4'>
                        <input
                            name={"bankingServicesRelated"}
                            className='mr-5 mt-1'
                            type="checkbox"
                            id={`checkbox-single`}
                            checked={bankingServicesRelated}
                            disabled={disabled}
                            onChange={(e) => setBankingServicesRelated(e.target.checked)}
                        />
                        <span className="pl-2">{t("externalization.riskProponentForm.bankingServicesRelated")}</span>
                    </label>

                    <label className='d-flex align-items-start pr-4'>
                        <input
                            name={"couldAffectRiskManagement"}
                            className='mr-5 mt-1'
                            type="checkbox"
                            id={`checkbox-single`}
                            checked={couldAffectRiskManagement}
                            disabled={disabled}
                            onChange={(e) => setCouldAffectRiskManagement(e.target.checked)}
                        />
                        <span className="pl-2">{t("externalization.riskProponentForm.couldAffectRiskManagement")}</span>
                    </label>

                    <label className='d-flex align-items-start pr-4'>
                        <input
                            name={"affectsInternalControl"}
                            className='mr-5 mt-1'
                            type="checkbox"
                            id={`checkbox-single`}
                            checked={affectsInternalControl}
                            disabled={disabled}
                            onChange={(e) => setAffectsInternalControl(e.target.checked)}
                        />
                        <span className="pl-2">{t("externalization.riskProponentForm.affectsInternalControl")}</span>
                    </label>

                    <label className='d-flex align-items-start pr-4'>
                        <input
                            name={"coreBusinessActivitiesInvolved"}
                            className='mr-5 mt-1'
                            type="checkbox"
                            id={`checkbox-single`}
                            checked={coreBusinessActivitiesInvolved}
                            disabled={disabled}
                            onChange={(e) => setCoreBusinessActivitiesInvolved(e.target.checked)}
                        />
                        <span className="pl-2">{t("externalization.riskProponentForm.coreBusinessActivitiesInvolved")}</span>
                    </label>

                    <label className='d-flex align-items-start pr-4'>
                        <input
                            name={"regulatoryConsentRequired"}
                            className='mr-5 mt-1'
                            type="checkbox"
                            id={`checkbox-single`}
                            checked={regulatoryConsentRequired}
                            disabled={disabled}
                            onChange={(e) => setRegulatoryConsentRequired(e.target.checked)}
                        />
                        <span className="pl-2">{t("externalization.riskProponentForm.regulatoryConsentRequired")}</span>
                    </label>

                    <label className='d-flex align-items-start pr-4'>
                        <input
                            name={"multipleContractsWithCurrentProvider"}
                            className='mr-5 mt-1'
                            type="checkbox"
                            id={`checkbox-single`}
                            checked={multipleContractsWithCurrentProvider}
                            disabled={disabled}
                            onChange={(e) => setMultipleContractsWithCurrentProvider(e.target.checked)}
                        />
                        <span className="pl-2">{t("externalization.riskProponentForm.multipleContractsWithCurrentProvider")}</span>
                    </label>
                </Col>
            </Row>
          {(bankingServicesRelated ||couldAffectRiskManagement || affectsInternalControl || coreBusinessActivitiesInvolved ||regulatoryConsentRequired || multipleContractsWithCurrentProvider) &&
           <>
               <CriticalExternalizationForm disabled={disabled}  proponentFormValues={proponentFormValues}/>
           </>}
          <Row className={'pb-5'}>
            <Col className="col-6 col-xl-3">
            <label className='d-flex align-items-start pr-4 mt-4'>
                <input
                    name={"isContractSigned"}
                    className='mr-5 mt-1'
                    type="checkbox"
                    id={`checkbox-single`}
                    checked={isContractSigned}
                    disabled={disabled}
                    onChange={(e) => setIsContractSigned(e.target.checked)}
                />
                <span className="pl-2">{t("externalization.riskProponentForm.isContractSigned")}</span>
            </label>
            </Col>
          </Row>

            {isContractSigned &&
             <ContractForm disabled={disabled} proponentFormValues={proponentFormValues}/>
            }
            {(!edit || (edit && !disabled)) && <Row className="mt-5 mb-3 form-footer">
                <button
                    className="secondary-btn"
                    type="reset"
                    onClick={handleCancelExternalization}>
                    {t('buttons.cancel')}
                </button>
                <button disabled={disabled || Object.values(isUploading || {}).some(Boolean)}
                        className="primary-btn">{t('buttons.save')}</button>
            </Row>}
        </form>
    </FormProvider>
          <VerifyExternalizationModal
            open={verifyModalOpen}
            formType={externalizationFormConfigData?.formKey}
            formId={proponentFormValues?.id ? proponentFormValues?.id : proposalFormId}
            isOpen={setVerifyModalOpen}
          />
            </>);
}

export default RiskProponent;